import React from 'react';
import {
    BlackFullLabel,
    DiamondBullet,
    H1
} from '@worthy-npm/clarity'

const PageHeader = (props) => {
    return (
        <React.Fragment>
            <BlackFullLabel text={props.label.title} overrideCSS={{backgroundColor: props.label.color, color: 'white', textTransform: 'none'}}/>
            <H1 bold={true} text={props.title}
                overrideCSS={{ fontFamily: 'Playfair Display', fontSize: '36px', margin: '5px 0', lineHeight: '50px'}}/>
            <DiamondBullet iconColor="grey" helper={true} html={props.diamondText}/>
        </React.Fragment>
    );
}

export default PageHeader;